import { z } from 'zod';
import { api } from '../lib/http';

const osSchema = z
  .object({
    id: z.string(),
    numeroOs: z.string(),
    descricao: z.string(),
    valor: z
      .union([z.string(), z.number(), z.null()])
      .transform((v) => (v == null ? null : String(v))),
    status: z.string(),
    finalizadaEm: z
      .union([z.string(), z.date(), z.null()])
      .transform((v) => (v == null ? null : String(v))),
    canceladaEm: z
      .union([z.string(), z.date(), z.null()])
      .transform((v) => (v == null ? null : String(v))),
    motivoCancelamento: z.string().nullable(),
    criadoEm: z.union([z.string(), z.date()]).transform(String),
    cliente: z.object({ id: z.string(), nome: z.string() }).nullable().optional(),
    veiculo: z
      .object({ placa: z.string(), marca: z.string().nullable(), modelo: z.string().nullable() })
      .nullable()
      .optional(),
  })
  .passthrough();
export type OrdemServico = z.infer<typeof osSchema>;

/** `GET /v1/ordens-servico?numero=` — a OS única pelo número exato (ou 404). */
export function buscarOsPorNumero(numero: string) {
  return api(osSchema, `/v1/ordens-servico?numero=${encodeURIComponent(numero)}`);
}

const listaSchema = z.object({
  total: z.number().int(),
  pagina: z.number().int(),
  limite: z.number().int(),
  itens: z.array(osSchema),
});

export function listarOrdensDoCliente(clienteId: string, pagina = 1, limite = 25) {
  return api(
    listaSchema,
    `/v1/ordens-servico?clienteId=${clienteId}&pagina=${pagina}&limite=${limite}`,
  );
}

/** `PATCH /v1/ordens-servico/:id/cancelar` — só relatório; não reverte voucher. */
export function cancelarOs(id: string, motivo: string) {
  return api(osSchema, `/v1/ordens-servico/${id}/cancelar`, {
    method: 'PATCH',
    body: { motivo },
  });
}
